var _feGaussianBlur, _feGaussianBlur2, _feGaussianBlur3, _animate, _animate2, _animate3, _animate4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _animate5, _animate6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetTheCodeNewAnimated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg748",
    width: "128.9mm",
    height: "34.186mm",
    viewBox: "0 0 128.9 34.186",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs546"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter5777",
    x: -0.05457,
    y: -0.29378,
    width: 1.1091,
    height: 1.5875,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur536",
    stdDeviation: 2.4102773
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter6006",
    x: -0.0023582,
    y: -0.012599,
    width: 1.0047,
    height: 1.0252,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur539",
    stdDeviation: 0.11336163
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1799",
    x: -0.002566,
    y: -0.01365,
    width: 1.0051,
    height: 1.0273,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1801",
    stdDeviation: 0.12340255
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g746",
    transform: "translate(-68.782 -58.838)",
    x: 0,
    y: 0,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path550",
    d: "m89.065 74.684a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54718-.5461.54405.55254 0 01.53453-.55887.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path552",
    d: "m83.848 81.686a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54718-.5461.54405.55254 0 01.53453-.55887.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path554",
    d: "m101.32 82.769a.54405.55254 0 01-.54088.55253.54405.55254 0 01-.54718-.5461.54405.55254 0 01.53453-.55888.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path556",
    d: "m103.19 71.106a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54718-.5461.54405.55254 0 01.53453-.55888.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path558",
    d: "m106.53 84.698a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54718-.5461.54405.55254 0 01.53453-.55888.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path560",
    d: "m112.76 70.393a.54405.55254 0 01-.54088.55253.54405.55254 0 01-.54718-.5461.54405.55254 0 01.53453-.55887.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path562",
    d: "m116.09 84.081a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54718-.5461.54405.55254 0 01.53453-.55887.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path564",
    d: "m118.4 69.929a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54718-.5461.54405.55254 0 01.53453-.55887.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path566",
    d: "m120.71 69.678a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54718-.5461.54405.55254 0 01.53453-.55887.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path568",
    d: "m125.38 83.35a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54717-.5461.54405.55254 0 01.53453-.55887.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path570",
    d: "m138.38 80.017a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54718-.5461.54405.55254 0 01.53453-.55887.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path572",
    d: "m131.01 76.491a.54405.55254 0 01-.54088.55253.54405.55254 0 01-.54718-.5461.54405.55254 0 01.53453-.55887.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path574",
    d: "m155.78 72.039a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54717-.5461.54405.55254 0 01.53453-.55887.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path576",
    d: "m157.84 78.504a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54717-.5461.54405.55254 0 01.53453-.55887.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path578",
    d: "m163.63 70.498a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54717-.5461.54405.55254 0 01.53453-.55888.54405.55254 0 01.55338.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path580",
    d: "m163.81 78.486a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54717-.5461.54405.55254 0 01.53453-.55888.54405.55254 0 01.55338.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path582",
    d: "m190.94 76.668a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54717-.5461.54405.55254 0 01.53453-.55887.54405.55254 0 01.55338.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path584",
    d: "m183.42 73.14a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54718-.5461.54405.55254 0 01.53453-.55888.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path586",
    d: "m175.28 77.696a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54717-.5461.54405.55254 0 01.53453-.55888.54405.55254 0 01.55338.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path588",
    d: "m179.3 65.718a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54718-.5461.54405.55254 0 01.53453-.55888.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path590",
    d: "m176.95 65.877a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54717-.5461.54405.55254 0 01.53452-.55888.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path592",
    d: "m93.964 79.282a.54405.55254 0 01-.54089.55253.54405.55254 0 01-.54718-.5461.54405.55254 0 01.53453-.55888.54405.55254 0 01.55339.53961",
    style: {
      fill: "#240e23",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g742",
    stroke: "#d6fff8",
    strokeWidth: 0.294
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow",
    style: {
      fill: "none",
      filter: "url(#filter6006)",
      strokeWidth: 1.1581,
      stroke: "#000001"
    },
    "aria-label": "Get the Code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path594",
    d: "m82.455 74.932c-1.3747.09498-2.5614.67937-3.4336 1.7031a.57912.57912 0 00-.002.002c-.86311 1.0202-1.26 2.27-1.1621 3.627.10093 1.3994.695 2.6116 1.7324 3.5234 1.0394.9137 2.3272 1.3397 3.7363 1.2422.9131-.06316 1.716-.32274 2.3594-.80078l.002-.002c.65222-.48147 1.1348-1.1881 1.457-2.0645a.57912.57912 0 00-.58398-.77734l-3.6562.25195a.57906.57906 0 00-.53906.61719.57906.57906 0 00.61719.53906l2.4805-.17188c-.16014.21217-.272.53169-.46484.67383a.57912.57912 0 00-.002.002c-.43712.32525-1.0044.5246-1.75.57617-1.1433.0791-2.0652-.22778-2.8926-.95508-.82938-.72898-1.2599-1.6031-1.3418-2.7383-.07886-1.0935.20766-1.9847.89062-2.793l.002-.002c.68649-.80478 1.523-1.2203 2.6309-1.2969 1.2656-.08758 2.3667.33361 3.4297 1.3496a.57906.57906 0 00.81836-.01953.57906.57906 0 00-.01758-.81836c-1.2474-1.1922-2.7264-1.7776-4.3105-1.668z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path596",
    d: "m82.26 72.479c-2.2406.155-4.0834 1.138-5.375 2.8809-1.089 1.4655-1.5775 3.1753-1.4434 5.0352.09792 1.3577.51377 2.6196 1.2383 3.752a.57912.57912 0 00.002.002c.73104 1.1325 1.6902 2.0019 2.8516 2.5723a.57912.57912 0 00.0039.002c1.1676.56369 2.4681.792 3.8652.69531 1.3098-.09049 2.4687-.46523 3.4336-1.1348.95977-.66607 1.7131-1.5921 2.248-2.7402.53683-1.152.7655-2.3691.67578-3.6133a.57912.57912 0 000-.01758l-.05859-.55273a.57912.57912 0 00-.61528-.51767l-6.3516.43945a.57906.57906 0 00-.53906.61719.57906.57906 0 00.61719.53906l5.7891-.40234c.07166 1.0442-.11028 2.0388-.56641 3.0176-.46106.98962-1.0773 1.7366-1.8594 2.2793-.77688.53906-1.7122.85293-2.8516.93164-1.224.08471-2.3057-.11207-3.2832-.58398-.97126-.47758-1.7568-1.1862-2.3848-2.1582-.62369-.97481-.97371-2.034-1.0586-3.2109-.11648-1.6151.28203-3.0019 1.2168-4.2598a.57912.57912 0 000-.002c1.109-1.4966 2.5652-2.2785 4.5254-2.4141 1.0246-.07088 1.9816.05817 2.8906.38672.73371.26543 1.5031.77193 2.2949 1.5449a.57906.57906 0 00.81836-.0098.57906.57906 0 00-.0098-.81836c-.87851-.85753-1.7775-1.4676-2.709-1.8046-1.0632-.38425-2.1925-.5362-3.3652-.45508z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path598",
    d: "m95.209 75.107c-1.5215.10514-2.8195.76581-3.7617 1.9238-.93787 1.1529-1.3517 2.587-1.2363 4.1875.11304 1.5684.73246 2.9091 1.8301 3.9062a.57912.57912 0 00.002.002c1.1039.99665 2.5203 1.4459 4.1113 1.3359 1.0146-.07017 1.9104-.31857 2.6641-.76562a.57912.57912 0 00.0039-.002c.75215-.45333 1.3728-1.1123 1.8535-1.9434a.57906.57906 0 00-.21094-.79102.57906.57906 0 00-.79101.21094c-.39798.68805-.8774 1.1853-1.4473 1.5293-.000747.000451-.0012.0015-.002.002-.56954.337-1.2782.54515-2.1504.60547-1.3385.09255-2.3773-.25011-3.2539-1.041-.88418-.80325-1.3597-1.8078-1.4551-3.1309-.09822-1.3625.22774-2.4497.98047-3.375.75897-.93278 1.695-1.4137 2.9434-1.5 1.3421-.09281 2.3822.25831 3.2617 1.0723a.57912.57912 0 000 .002c.85.78161 1.3247 1.849 1.4512 3.2793l-6.9394.47842a.57912.57912 0 00-.52539.70898c.18344.79013.59215 1.4603 1.2012 1.9219a.57912.57912 0 00.0059.0039c.62213.45876 1.3994.65169 2.2383.59375 1.0156-.07029 1.9167-.52812 2.5879-1.3105a.57906.57906 0 00-.0625-.81641.57906.57906 0 00-.81641.0625c-.49581.57798-1.0535.85924-1.7891.91016-.6255.0432-1.0828-.087-1.4688-.37109-.18753-.14304-.24806-.4129-.37305-.61133l6.6094-.45703a.57912.57912 0 00.53906-.60742l-.0254-.46484a.57912.57912 0 00-.002-.01172c-.12392-1.7162-.73818-3.1411-1.8457-4.1602-1.1046-1.0222-2.5277-1.4875-4.127-1.377z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path600",
    d: "m104.45 71.119a.57906.57906 0 00-.53515.61914l.25781 3.5801a.57912.57912 0 00.61719.53516l.81445-.05664.0684.94336-.8125.05664a.57912.57912 0 00-.53711.61914l.54883 7.6113a.57906.57906 0 00.61914.53711.57906.57906 0 00.53711-.61914l-.50781-7.0332.81054-.05664a.57912.57912 0 00.53907-.61914l-.15235-2.0977a.57912.57912 0 00-.61718-.53711l-.81446.05664-.21679-3.002a.57906.57906 0 00-.61915-.53711z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path602",
    d: "m114.14 70.449a.57906.57906 0 00-.0137.002.57906.57906 0 00-.53515.61914l.25781 3.5781a.57912.57912 0 00.61719.53711l.81445-.05664.0684.94141-.8125.05664a.57912.57912 0 00-.53712.61909l.54883 7.6133a.57906.57906 0 00.61914.53516.57906.57906 0 00.53711-.61914l-.50781-7.0332.8125-.05664a.57912.57912 0 00.53711-.61914l-.1504-2.0977a.57912.57912 0 00-.61914-.53516l-.81445.05664-.2168-3.0039a.57906.57906 0 00-.60547-.53711z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path604",
    d: "m111.79 70.609a.57906.57906 0 00-.53516.61914l.2168 3-.62305.04297a.57912.57912 0 00-.53906.61914l.15234 2.0977a.57912.57912 0 00.61719.53516l.625-.04297.50781 7.0371a.57906.57906 0 00.61914.53711.57906.57906 0 00.53711-.61914l-.54883-7.6133a.57912.57912 0 00-.61914-.53711l-.625.04492-.0684-.94336.62305-.04297a.57912.57912 0 00.53711-.61914l-.25781-3.5781a.57906.57906 0 00-.61914-.53711z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path606",
    d: "m122.09 75.486c-.60773.04197-1.1702.31216-1.5801.76172a.57912.57912 0 00-.004.0039c-.4001.44674-.64374 1.0253-.74805 1.6836-.0709.44701-.0408 1.0848.0352 2.1387l.28124 3.9004a.57906.57906 0 00.61915.53516.57906.57906 0 00.53711-.61914l-.28126-3.9004c-.0741-1.0287-.0719-1.7275-.0488-1.873.0775-.48923.23967-.83553.46679-1.0898.22949-.25089.46147-.36315.80274-.38672.26255-.01822.42594.03124.57031.13086a.57912.57912 0 00.006.0039c.14049.09449.26728.25409.36914.55859a.57912.57912 0 00.002 0c.09.26685.21131 1.0241.29102 2.1309l.30664 4.2578a.57906.57906 0 00.61914.53516.57906.57906 0 00.53516-.61914l-.30664-4.2559c-.0823-1.1424-.17559-1.9018-.34961-2.418-.15977-.47606-.42954-.88359-.81836-1.1465-.37507-.2576-.83655-.36452-1.3047-.33203z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path608",
    d: "m119.65 69.898a.57906.57906 0 00-.0137.002.57906.57906 0 00-.53515.61914l.34179 4.7285a.57912.57912 0 00.99219.36328c.39462-.40676.78471-.70626 1.168-.90625a.57912.57912 0 00.006-.002c.38411-.20557.76188-.31484 1.1523-.3418.78968-.05463 1.4051.15952 1.9844.6875.44669.41347.73841 1.0766.8125 2.0996l.46289 6.418a.57906.57906 0 00.61914.53516.57906.57906 0 00.53515-.61914l-.46289-6.416c-.0878-1.212-.46175-2.2054-1.1836-2.8711a.57912.57912 0 00-.002-.0039c-.78671-.71702-1.7794-1.0601-2.8457-.98633-.55749.0385-1.101.2014-1.6133.47461-.19216.10027-.36248.28954-.54687.41992l-.26563-3.6641a.57906.57906 0 00-.60547-.53711z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path610",
    d: "m117.33 70.057a.57906.57906 0 00-.0137.002.57906.57906 0 00-.53516.61914l.97071 13.457a.57906.57906 0 00.61914.53711.57906.57906 0 00.53711-.61914l-.97263-13.459a.57906.57906 0 00-.60547-.53711z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path612",
    d: "m150.52 70.207c-1.3446.09295-2.5068.67944-3.3652 1.7012a.57912.57912 0 00-.002.002c-.85388 1.0226-1.2408 2.2841-1.1406 3.666.0688.95518.33401 1.82.80469 2.5605.46951.73877 1.117 1.3147 1.9043 1.6992.7893.38504 1.6585.54726 2.5684.48437.77188-.05341 1.4881-.25491 2.125-.60547a.57912.57912 0 00.004-.002c.64983-.36532 1.2898-.95068 1.959-1.7461a.57906.57906 0 00-.0703-.81445.57906.57906 0 00-.8164.07031c-.61281.72839-1.1744 1.2184-1.6406 1.4805-.47983.2631-1.0188.41791-1.6406.46094-.72811.05032-1.3738-.07318-1.9805-.36914-.60672-.29631-1.0731-.71207-1.4336-1.2793-.35932-.5653-.57172-1.2294-.62891-2.0234-.0818-1.1289.20287-2.0349.875-2.8398.67757-.80647 1.4872-1.217 2.5586-1.291 1.2621-.08722 2.4123.36532 3.5606 1.459a.57906.57906 0 00.81836-.02148.57906.57906 0 00-.0195-.81836c-1.3218-1.2589-2.8395-1.884-4.4395-1.7734z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path614",
    d: "m150.38 67.777c-1.3223.09143-2.5524.51698-3.6523 1.2637a.57912.57912 0 000 .002c-1.0908.7444-1.9248 1.7032-2.4668 2.8535a.57912.57912 0 00-.002.002c-.53894 1.1528-.75036 2.4438-.65039 3.8359.15457 2.1418.96767 3.927 2.4199 5.2383a.57912.57912 0 00.002.002c1.4584 1.3049 3.3009 1.8945 5.3906 1.75 1.1296-.07825 2.1446-.34418 3.0293-.80664a.57912.57912 0 00.004-.002c.89423-.47484 1.7735-1.2418 2.6699-2.2891a.57906.57906 0 00-.0625-.81641.57906.57906 0 00-.8164.0625c-.83284.97302-1.6208 1.6414-2.332 2.0195-.72335.37814-1.5739.60663-2.5723.67578-1.8353.12687-3.3039-.35253-4.5371-1.4551l-.002-.002c-1.2284-1.1101-1.9017-2.5578-2.0391-4.4609-.088-1.2259.0978-2.3011.54688-3.2617.45405-.96258 1.1339-1.7516 2.0703-2.3906.93941-.63718 1.9532-.98849 3.0801-1.0664.95617-.06623 1.883.07943 2.8027.44141.9222.36086 1.7277.90375 2.4316 1.6426a.57906.57906 0 00.81835.01953.57906.57906 0 00.0195-.81836c-.81366-.85397-1.7685-1.5001-2.8457-1.9219h-.002c-1.0697-.42069-2.1795-.59551-3.3047-.51758z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path616",
    d: "m162.56 72.748c-.86729.05989-1.6379.46049-2.1758 1.1367-.53711.67521-.76827 1.537-.70117 2.4707.0688.95316.41446 1.7813 1.0391 2.3789a.57906.57906 0 00.81836-.01758.57906.57906 0 00-.0195-.81836c-.4014-.38403-.63041-.89031-.6836-1.627-.0509-.70831.10424-1.2255.45313-1.6641.35809-.45017.7629-.66261 1.3496-.70312.60718-.04209 1.0388.11305 1.4434.5a.57912.57912 0 00.006.0039c.40527.37907.63354.87183.68554 1.5938.0519.72067-.10467 1.247-.45898 1.6914a.57912.57912 0 000 .002c-.35761.44957-.76356.66205-1.3574.70313a.57906.57906 0 00-.53906.61719.57906.57906 0 00.61718.53711c.87214-.06032 1.6472-.45988 2.1856-1.1367.54369-.68198.77512-1.5508.70703-2.4961-.0679-.94207-.41673-1.7638-1.0449-2.3535l-.002-.002c-.62124-.59315-1.4444-.87726-2.3223-.81641z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path618",
    d: "m162.37 70.459c-1.3581.09392-2.5652.69104-3.5254 1.7285a.57912.57912 0 00-.002.002c-1.0961 1.1923-1.6023 2.6848-1.4824 4.3379.11125 1.5445.7462 2.8816 1.8633 3.9023a.57912.57912 0 00.004.002c1.1216 1.0127 2.4857 1.495 3.9668 1.3926 1.0044-.06943 1.933-.3868 2.7402-.94336a.57912.57912 0 00.002-.002c.80494-.56156 1.4273-1.3163 1.8438-2.2285v-.002c.42321-.91311.59995-1.8925.52735-2.9004-.0726-1.0019-.38393-1.9367-.92774-2.7715-.54485-.83814-1.2817-1.4957-2.1797-1.9434a.57906.57906 0 00-.77735.25977.57906.57906 0 00.25977.77734c.72404.36095 1.2894.86465 1.7266 1.5371.4402.67578.68478 1.4059.74414 2.2246.0594.82388-.0796 1.5881-.42383 2.3301a.57912.57912 0 00-.002.0039c-.3375.74061-.81324 1.3173-1.4531 1.7637-.63825.43954-1.3455.68197-2.1602.73828-1.196.08271-2.1896-.2641-3.1094-1.0938l-.002-.002c-.91352-.83564-1.3956-1.8422-1.4883-3.1289-.10008-1.3803.28121-2.4904 1.1797-3.4688l.002-.002c.78927-.85187 1.675-1.2848 2.7539-1.3594a.57906.57906 0 00.53906-.61719.57906.57906 0 00-.61914-.53711z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path620",
    d: "m178.23 65.848a.57906.57906 0 00-.53515.61914l.96875 13.459a.57906.57906 0 00.61914.53516.57906.57906 0 00.53711-.61914l-.97071-13.457a.57906.57906 0 00-.61914-.53711z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path622",
    d: "m175.89 66.008a.57906.57906 0 00-.5371.61914l.26757 3.6973c-.19741-.10786-.37017-.2832-.57812-.35938-.58494-.21428-1.2079-.29991-1.8438-.25586-1.3703.09477-2.5548.7509-3.4219 1.877-.87587 1.1361-1.2487 2.561-1.1328 4.1699.11349 1.5628.70532 2.9028 1.7598 3.916a.57912.57912 0 00.002.002c1.046.9997 2.316 1.4907 3.6777 1.3965.60829-.04206 1.1801-.19537 1.6973-.46094a.57912.57912 0 00.004-.002c.19599-.10232.36282-.31105.54882-.44922a.57906.57906 0 00.60938.46289.57906.57906 0 00.53711-.61914l-.0742-1.0254a.57912.57912 0 00-1.0137-.3418c-.38776.44141-.77105.75175-1.1406.94531-.00054.000278-.001-.000278-.002 0-.00069.000359-.001.0016-.002.002-.36987.18929-.77797.2998-1.2441.33203-1.0522.07279-1.9409-.26003-2.7969-1.0781-.84879-.81617-1.3117-1.8357-1.4082-3.1641-.10011-1.3899.20436-2.4812.89648-3.3789.69896-.90775 1.5163-1.3539 2.584-1.4277.48418-.03355.93417.02958 1.3652.1875.43042.15768.84342.41213 1.2441.7793a.57912.57912 0 00.96875-.46875l-.34765-4.8203a.57906.57906 0 00-.61915-.53516zm-73.756 5.2695a.57906.57906 0 00-.0137.002.57906.57906 0 00-.53515.61914l.21679 3-.62304.04297a.57912.57912 0 00-.53907.61914l.15235 2.0957a.57912.57912 0 00.61719.53711l.625-.04297.50781 7.0371a.57906.57906 0 00.61914.53516.57906.57906 0 00.53711-.61914l-.54883-7.6133a.57912.57912 0 00-.61914-.53516l-.625.04297-.0684-.94141.62305-.04297a.57912.57912 0 00.53711-.61914l-.25782-3.5801a.57906.57906 0 00-.60546-.53711zm30.363 3.1152c-.76539.05286-1.4661.33678-2.0234.83398a.57906.57906 0 00-.0449.81836.57906.57906 0 00.8164.04687c.37263-.3324.78946-.50758 1.3301-.54492.49242-.034.88947.06705 1.2637.30859a.57912.57912 0 00.002.002c.10551.06731.12947.18835.21484.26562l-4.002.27734a.57906.57906 0 00-.53907.61719.57906.57906 0 00.61915.53711l5.0723-.34961a.57912.57912 0 00.50391-.77734c-.23438-.64129-.66571-1.1752-1.2441-1.5449-.5798-.37426-1.2592-.53923-1.9688-.49023z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path624",
    d: "m132.23 72.342c-1.521.1051-2.8201.76639-3.7617 1.9238-.9387 1.153-1.3539 2.5871-1.2383 4.1875.11284 1.5685.73436 2.9092 1.832 3.9062a.57912.57912 0 00.002 0c1.1036.99678 2.5204 1.4479 4.1113 1.3379 1.0144-.07017 1.9103-.3186 2.6641-.76562a.57912.57912 0 00.004-.002c.75156-.45321 1.3724-1.1143 1.8535-1.9453a.57906.57906 0 00-.21094-.79102.57906.57906 0 00-.79102.21094c-.39837.68809-.87976 1.1873-1.4492 1.5312-.00074.00045-.001.0015-.002.002-.56967.33703-1.2765.54515-2.1484.60547-1.338.09252-2.3779-.25074-3.2539-1.041l-.002-.002c-.88296-.80298-1.358-1.8091-1.4531-3.1309-.0984-1.3626.22522-2.4478.97851-3.373a.57912.57912 0 00.002 0c.75828-.9326 1.6949-1.4137 2.9434-1.5 1.3425-.09282 2.3802.25827 3.2598 1.0723a.57912.57912 0 00.002.002c.85023.78166 1.3246 1.8491 1.4512 3.2793l-6.9414.47852a.57912.57912 0 00-.52344.70898c.184.79004.59127 1.4604 1.1992 1.9219a.57912.57912 0 00.008.0039c.62257.45835 1.3999.6517 2.2383.59375 1.0159-.07028 1.917-.5298 2.5879-1.3125a.57906.57906 0 00-.0625-.81641.57906.57906 0 00-.81641.0625c-.49514.5777-1.053.85924-1.7891.91016-.62305.04307-1.0804-.08437-1.4668-.36719-.18845-.1434-.24926-.414-.375-.61328l6.6094-.45703a.57912.57912 0 00.53711-.60938l-.0234-.46289a.57912.57912 0 00-.002-.01172c-.12389-1.7159-.73854-3.1412-1.8457-4.1602-1.1045-1.0222-2.5274-1.4875-4.127-1.377z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path626",
    d: "m185.04 71.084c-.76538.05286-1.4641.33873-2.0215.83594a.57906.57906 0 00-.0469.81641.57906.57906 0 00.81641.04687c.37262-.3324.78946-.50758 1.3301-.54492.49242-.034.88947.06705 1.2637.30859a.57912.57912 0 00.002.002c.10551.06731.12947.18835.21485.26562l-4.0039.27734a.57906.57906 0 00-.53711.61719.57906.57906 0 00.61719.53711l5.0742-.34961a.57912.57912 0 00.5039-.77734c-.23438-.64129-.6657-1.1752-1.2441-1.5449-.5798-.37426-1.2592-.53923-1.9688-.49024z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path628",
    d: "m184.79 69.031c-1.5216.10514-2.82.76758-3.7617 1.9258-.93741 1.1527-1.3519 2.5868-1.2363 4.1875.11284 1.5685.73241 2.9092 1.8301 3.9062a.57912.57912 0 00.002 0c1.1036.99678 2.5204 1.4479 4.1113 1.3379 1.0144-.07017 1.9103-.3186 2.6641-.76562a.57912.57912 0 00.004-.002c.75294-.45336 1.3726-1.1146 1.8535-1.9453a.57906.57906 0 00-.21094-.79102.57906.57906 0 00-.79102.21094c-.39856.68842-.87719 1.1875-1.4473 1.5312-.57023.33818-1.2787.54504-2.1524.60547-1.338.09252-2.3779-.24878-3.2539-1.0391l-.002-.002c-.88296-.80298-1.358-1.8091-1.4531-3.1309-.0984-1.3623.22788-2.4476.98047-3.373.75828-.9326 1.6949-1.4137 2.9434-1.5 1.3425-.09282 2.3811.25804 3.2617 1.0723.8494.78169 1.3247 1.851 1.4512 3.2812l-6.9395.47852a.57912.57912 0 00-.52539.70898c.18296.79054.592 1.4604 1.2012 1.9219a.57912.57912 0 00.006.0039c.62191.45878 1.399.65168 2.2383.59375 1.015-.0703 1.9162-.53016 2.5879-1.3125a.57906.57906 0 00-.0606-.81641.57906.57906 0 00-.81641.0625c-.4963.57806-1.0561.85926-1.791.91016-.625.04314-1.0814-.08405-1.4668-.36719-.18896-.1435-.24933-.41403-.375-.61328l6.6094-.45703a.57912.57912 0 00.53906-.60938l-.0254-.46484a.57912.57912 0 00-.002-.0098c-.12398-1.7169-.73839-3.1431-1.8457-4.1621-1.1052-1.0212-2.528-1.4875-4.127-1.377z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#000001",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "tubeOn",
    style: {
      fill: "none",
      filter: "url(#filter1799)",
      strokeLinejoin: "round",
      strokeOpacity: 0.89412,
      strokeWidth: 1.2353
    },
    "aria-label": "Get the Code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path631",
    d: "m82.932 74.332c-1.3758.0951-2.5648.6799-3.4429 1.7106l-.0019.0023c-.869 1.0271-1.2753 2.296-1.1762 3.6704.1022 1.4172.7081 2.651 1.7532 3.5696 1.0472.9205 2.3399 1.3468 3.7501 1.2492.9148-.0632 1.7173-.3236 2.365-.8055.6562-.4845 1.1464-1.2001 1.4718-2.0849.0744-.2014.0439-.4293-.0807-.6037-.1246-.1745-.3259-.2712-.5336-.2564l-3.656.2528c-.1609.011-.3104.088-.4156.2142-.1052.1261-.1575.2909-.1453.4581.0119.1673.0873.3233.2096.4336.1222.1104.2813.1661.4422.1549l2.3887-.1652c-.1388.169-.2284.4473-.3912.5673l-.002 1e-4c-.4332.3223-.999.5225-1.7438.574-1.1422.079-2.0592-.2289-2.8787-.9493-.8218-.7222-1.2405-1.5751-1.3211-2.6926-.0777-1.0769.2012-1.9475.8798-2.7495.6805-.7977 1.5127-1.2127 2.6195-1.2893 1.2643-.0874 2.3586.3313 3.4143 1.3403.1191.1142.2768.1748.438.1684.1613-.0064.313-.0792.4215-.2025.2256-.2556.2078-.6545-.0398-.8914-1.2546-1.1991-2.7394-1.7852-4.3249-1.6755z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path633",
    d: "m82.737 71.879c-2.2411.155-4.0875 1.1385-5.3857 2.8895-1.0946 1.473-1.5889 3.2034-1.4536 5.0796.0988 1.3698.5191 2.6437 1.249 3.7845l2e-4.0022c.7365 1.1409 1.7031 2.0155 2.8684 2.5878l.0042.0018c1.1716.5656 2.4736.7951 3.8714.6985 1.3106-.0907 2.4714-.4643 3.4396-1.1362.9629-.6682 1.7202-1.6021 2.2588-2.758.5406-1.1602.7733-2.3899.6826-3.647-3e-4-.0063-8e-4-.0126-.0013-.019l-.0583-.5532c-.0351-.3384-.3217-.5893-.6482-.5674l-6.353.4393c-.1608.0109-.3104.088-.4156.2141s-.1574.2909-.1452.4581c.0119.1673.0873.3233.2095.4337.1223.1104.2814.1661.4422.1548l5.7427-.3971c.0596 1.0094-.1057 1.974-.5492 2.9258-.4575.9819-1.0672 1.7228-1.8462 2.2633-.7736.5369-1.7103.8514-2.8491.9301-1.2217.0845-2.2993-.1123-3.272-.5809l-.0042-.0019c-.9665-.4756-1.7454-1.1786-2.3675-2.1415-.6183-.9663-.9642-2.0107-1.0482-3.1755-.1153-1.5987.2768-2.9689 1.2059-4.2192 1.1023-1.4875 2.5547-2.2699 4.5137-2.4054 1.024-.0708 1.9803.0596 2.887.3872l-1e-4-.0021c.7307.2643 1.4948.7675 2.2832 1.5371.2452.2398.6294.2293.8583-.0234.2287-.2528.2154-.6521-.0297-.892-.882-.861-1.7862-1.4739-2.7208-1.8119-1.0655-.3851-2.1954-.5368-3.3688-.4557z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path635",
    d: "m95.688 74.507c-1.5226.1052-2.825.7669-3.7734 1.9326-.9441 1.1605-1.3663 2.6164-1.2497 4.2328.1142 1.5848.7462 2.946 1.8519 3.9504 1.1124 1.0045 2.534 1.4563 4.126 1.3462 1.0152-.0702 1.9109-.3207 2.6671-.7692.0013-9e-4.0026-.0017.0039-.0025.7551-.4548 1.3821-1.1183 1.8661-1.9554.172-.2974.079-.6854-.209-.8669-.138-.0877-.304-.1147-.461-.0753-.156.0395-.291.1422-.374.2855-.3942.6819-.8679 1.1744-1.435 1.5167-.5675.3366-1.2758.5459-2.149.6063-1.3369.0924-2.3714-.2498-3.2393-1.0324l-.0022-.002c-.8746-.7955-1.3389-1.7799-1.433-3.0854-.0971-1.3466.2199-2.412.9664-3.3297.7527-.9252 1.6878-1.4049 2.935-1.4911 1.3411-.0928 2.3747.2578 3.2456 1.0637l.0022.002c.8295.7629 1.2843 1.7992 1.4173 3.1839l-6.9042.4775c-.1778.0122-.3408.105-.4459.2538-.105.1488-.1414.3386-.0995.5191.1867.8043.6049 1.489 1.2211 1.9559.0022.002.0044.0041.0066.0061.6295.4641 1.4103.6567 2.2502.5986 1.0168-.0703 1.92-.5305 2.5969-1.3194.2218-.2589.1986-.6573-.052-.8905-.251-.2327-.6343-.2119-.8566.0465-.4903.5714-1.0449.8519-1.7792.9027-.6235.0431-1.0787-.0856-1.4568-.3632-.161-.1224-.2039-.3578-.3166-.5184l6.55-.4529c.329-.0225.579-.3146.562-.6576l-.026-.4664c0-.0036 0-.0072-.001-.0108-.124-1.7306-.748-3.1789-1.8639-4.206-1.1133-1.0303-2.5406-1.496-4.141-1.3854z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path637",
    d: "m104.93 70.52c-.161.011-.311.088-.416.2141s-.157.291-.145.4582l.258 3.5776c.012.1673.087.3233.21.4337.122.1103.281.166.442.1548l.784-.0543.061.837-.785.0542c-.161.011-.31.0881-.416.2142-.105.1261-.157.2909-.145.4581l.549 7.6128c.012.1673.087.3233.21.4336.122.1104.281.1661.442.1549.334-.024.584-.3248.559-.6722l-.504-6.9824.785-.0543c.161-.011.31-.088.416-.2141.105-.1261.157-.291.145-.4582l-.151-2.0977c-.026-.3473-.318-.6097-.652-.5863l-.785.0543-.212-2.9494c-.025-.3475-.316-.6108-.65-.5886z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path639",
    d: "m114.61 69.851c-.334.0239-.584.3247-.559.6721l.258 3.5777c.025.3474.316.6107.65.5885l.785-.0542.06.8369-.785.0543c-.334.024-.584.3247-.558.6721l.549 7.6128c.024.3475.315.6109.649.5886.161-.011.311-.088.416-.2141s.157-.291.145-.4582l-.503-6.9824.784-.0543c.161-.011.311-.088.416-.2141s.157-.291.145-.4582l-.151-2.0977c-.026-.3473-.317-.6097-.652-.5863l-.784.0543-.213-2.9494c-.012-.1672-.087-.3233-.21-.4336-.122-.1104-.281-.1661-.442-.1548z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path641",
    d: "m112.27 70.011c-.333.0239-.583.3233-.559.67l.213 2.9494-.596.0412c-.161.011-.311.0881-.416.2142s-.157.2909-.145.4581l.151 2.0977c.012.1672.087.3232.21.4336.122.1104.281.1661.442.1548l.596-.0412.503 6.9824c.025.3475.316.6109.65.5886.161-.0109.311-.088.416-.2141s.157-.2909.145-.4582l-.549-7.6127c-.012-.1673-.087-.3233-.209-.4337-.123-.1103-.282-.166-.443-.1548l-.596.0412-.06-.8369.596-.0413c.161-.0109.31-.088.416-.2141.105-.1261.157-.2909.145-.4581l-.258-3.5798c-.026-.3474-.318-.6097-.652-.5863z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path643",
    d: "m122.57 74.886c-.609.0421-1.174.313-1.59.7688-.001.0016-.002.0031-.003.0046-.406.4529-.656 1.0431-.761 1.7116-.075.4671-.041 1.1009.035 2.1566l.281 3.9002c.012.1672.087.3232.21.4336.122.1104.281.1661.442.1548.161-.0109.31-.088.415-.2141.106-.1261.158-.2909.146-.4582l-.282-3.9002c-.074-1.0268-.068-1.7293-.048-1.8548v-.0021c.076-.4782.231-.8108.452-1.0588.224-.2462.452-.3576.793-.3812.262-.0181.423.0311.562.1264l.006.0039c.133.0896.251.2347.35.5288.085.2507.207 1.0092.287 2.1137l.307 4.2565c.012.1673.087.3233.21.4337.122.1104.281.166.442.1548.161-.011.31-.088.415-.2141.106-.1262.158-.291.146-.4582l-.307-4.2565c-.083-1.1445-.174-1.9053-.353-2.4376-.165-.4879-.444-.9087-.841-1.177-.382-.2614-.846-.3675-1.314-.335z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path645",
    d: "m120.12 69.301c-.334.0228-.585.3227-.561.6702l.341 4.7308c.018.2463.172.4604.395.548s.473.0326.641-.1408c.391-.4042.78-.7009 1.162-.9003.002-8e-4.004-.0017.006-.0026.382-.2044.759-.3131 1.149-.34.787-.0544 1.398.1598 1.969.6795.437.4038.721 1.0439.794 2.0554l.463 6.4174c.025.3475.315.6108.65.5886.16-.011.31-.088.415-.2141.105-.1262.158-.291.145-.4582l-.462-6.4174c-.089-1.2246-.47-2.2395-1.203-2.9149l-.004-.0019c-.795-.7241-1.791-1.069-2.858-.9952-.56.0387-1.107.2026-1.622.4787-.18.0941-.339.273-.512.3935l-.259-3.5903c-.025-.3466-.316-.6087-.649-.5865z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path647",
    d: "m117.79 69.459c-.334.0228-.585.3227-.561.6702l.97 13.459c.012.1672.088.3232.21.4336s.281.1661.442.1548c.161-.0109.31-.088.416-.2141.105-.1261.157-.2909.145-.4582l-.971-13.459c-.025-.3473-.317-.6097-.651-.5863z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path649",
    d: "m150.99 69.606c-1.345.093-2.511.6812-3.375 1.7102l-.002 1e-4c-.86 1.0298-1.254 2.3126-1.153 3.7112.069.9661.34 1.8462.817 2.5962.475.7476 1.129 1.3283 1.921 1.7147.793.387 1.662.5482 2.572.4853.773-.0534 1.49-.253 2.129-.6049l.004-.0024c.652-.3667 1.293-.955 1.964-1.7525.22-.261.193-.6591-.06-.8899-.253-.2302-.636-.2057-.856.0549-.61.7252-1.169 1.2122-1.632 1.473l-.002.0023c-.477.2619-1.016.4178-1.638.4608-.726.0502-1.37-.074-1.972-.3679-.604-.2945-1.063-.706-1.418-1.2643-.354-.556-.562-1.2058-.619-1.9891-.08-1.1114.198-1.9954.863-2.7928.671-.7993 1.479-1.2103 2.548-1.2843 1.261-.0872 2.403.3627 3.545 1.4499.119.1139.277.1741.438.1673.162-.0067.313-.0799.421-.2034.225-.2562.207-.655-.042-.8912-1.328-1.2655-2.851-1.894-4.453-1.7833z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path651",
    d: "m150.86 67.177c-1.323.0914-2.554.517-3.656 1.2656l-.002.0023c-1.094.7462-1.932 1.7118-2.479 2.8706l-.002.0024c-.543 1.1618-.758 2.4662-.657 3.8696.156 2.1577.981 3.9639 2.442 5.2827l.002.0021c1.467 1.3124 3.312 1.9003 5.403 1.7557 1.13-.0782 2.147-.3416 3.033-.8051l.004-.0025c.897-.4759 1.779-1.2478 2.677-2.2975.221-.2594.197-.6577-.054-.8904-.121-.1121-.279-.17-.44-.1609s-.312.0845-.418.2094c-.831.9706-1.614 1.6356-2.323 2.0124-.721.3771-1.572.6066-2.57.6757-1.834.1268-3.297-.3529-4.522-1.448l-.003-.002c-1.22-1.1024-1.882-2.5285-2.018-4.4157-.087-1.2146.096-2.2768.54-3.2282.451-.9534 1.123-1.7361 2.056-2.3732.937-.6362 1.952-.9866 3.078-1.0645.956-.0662 1.88.077 2.797.4379l.002.002c.92.3598 1.72.8997 2.419 1.6337.237.2485.621.2523.858.0085.115-.1174.179-.2776.18-.4454 0-.1678-.064-.3293-.179-.4488-.818-.8588-1.777-1.5068-2.857-1.9296l-.003 1e-4c-1.071-.4217-2.181-.597-3.308-.5191z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path653",
    d: "m163.04 72.149c-.868.0601-1.641.4612-2.185 1.1449l-.002 1e-4c-.544.6834-.78 1.5645-.712 2.5133.07.9676.424 1.8188 1.057 2.4249.248.2365.632.2213.858-.0339.226-.2551.209-.654-.038-.8915-.392-.3755-.612-.8612-.664-1.5834-.05-.6932.097-1.1891.439-1.6195.353-.4427.753-.6558 1.338-.6963.607-.042 1.034.1135 1.429.4923.003.002.005.004.007.006.397.3709.615.8424.666 1.5494.051.7055-.1 1.2112-.448 1.6475-.351.4418-.753.656-1.345.6969-.335.0228-.586.3227-.561.6702.012.1673.087.3233.209.4336.122.1104.282.1661.442.1548.873-.0603 1.651-.4608 2.196-1.1455.549-.69.787-1.5808.718-2.5412-.069-.9582-.429-1.8008-1.068-2.3988-.629-.6004-1.457-.8844-2.336-.8237z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path655",
    d: "m162.85 69.859c-1.36.094-2.57.693-3.535 1.736l-.002 1e-4c-1.102 1.1987-1.616 2.7142-1.496 4.3854.113 1.5616.758 2.9186 1.882 3.9463l.005.0019c1.129 1.0196 2.498 1.501 3.981 1.3985 1.005-.0695 1.934-.3856 2.744-.944l.002-.0023c.808-.5642 1.437-1.3233 1.857-2.2451v-.0022c.426-.921.606-1.9126.533-2.9331-.073-1.0145-.39-1.963-.938-2.806-.551-.8465-1.298-1.5086-2.2-1.9582-.303-.1509-.665-.0187-.808.2953-.143.3141-.012.6911.291.8422.721.3591 1.279.8575 1.712 1.5216.434.6676.674 1.3828.732 2.1888.059.8113-.077 1.562-.417 2.2959l-.002.0045c-.334.7313-.806 1.2996-1.441 1.7438-.637.4385-1.341.6839-2.156.7402-1.195.0826-2.184-.264-3.097-1.0868l-.002-.002c-.905-.8285-1.376-1.8135-1.467-3.083-.098-1.3633.274-2.4538 1.167-3.4262.784-.8464 1.668-1.2764 2.746-1.3509.16-.011.31-.088.415-.2141s.158-.291.145-.4582c-.012-.1672-.087-.3232-.209-.4336s-.282-.1661-.442-.1548z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path657",
    d: "m178.71 65.249c-.334.0228-.585.3227-.561.6702l.971 13.459c.012.1672.087.3233.209.4336.122.1104.282.1661.442.1548.161-.0109.311-.088.416-.2141s.157-.2909.145-.4581l-.97-13.459c-.026-.3474-.318-.6098-.652-.5864z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path659",
    d: "m176.37 65.409c-.334.0228-.585.3226-.561.6701l.262 3.6283c-.188-.1003-.35-.2695-.547-.3415-.587-.2151-1.209-.2998-1.846-.2558-1.372.0949-2.561.7503-3.435 1.8838-.882 1.1445-1.26 2.5912-1.143 4.2148.114 1.5789.718 2.9388 1.78 3.9597v.0022c1.053 1.0066 2.33 1.4978 3.694 1.4035.609-.0421 1.18-.1942 1.699-.4607l.004-3e-4c.189-.0985.349-.301.529-.4328.085.2808.344.4657.625.4462.334-.0239.585-.3247.559-.6721l-.074-1.0267c-.019-.2511-.179-.4677-.409-.5512-.229-.0836-.483-.0182-.646.1665-.386.4393-.766.7461-1.134.9386-.369.1895-.777.3016-1.244.3339-1.051.0727-1.934-.2592-2.783-1.0703-.842-.8087-1.294-1.8074-1.389-3.1202-.099-1.3753.197-2.4472.882-3.3366.694-.9003 1.51-1.3438 2.576-1.4175.485-.0335.931.0285 1.36.1856.428.1568.836.4087 1.234.7728.186.1693.451.2062.671.0935s.351-.3527.333-.6079l-.347-4.8194c-.026-.3466-.316-.6087-.65-.5865zm-73.77 5.2707c-.334.024-.584.3247-.559.6721l.212 2.9473-.596.0413c-.161.011-.31.088-.415.2141-.106.1261-.158.2909-.146.4581l.152 2.0977c.012.1673.087.3233.209.4336.122.1104.282.1661.442.1549l.597-.0413.503 6.9825c.025.3474.315.6108.65.5885.161-.0109.31-.088.415-.2141s.158-.2909.146-.4581l-.549-7.6128c-.012-.1673-.088-.3233-.21-.4336-.122-.1104-.281-.1661-.442-.1549l-.594.0411-.061-.837.595-.041c.16-.011.31-.0881.415-.2142s.158-.2909.145-.4581l-.258-3.5777c-.011-.1672-.087-.3232-.209-.4336s-.281-.1661-.442-.1548zm30.375 3.1138c-.766.0529-1.467.3379-2.029.8394-.253.2264-.28.6247-.06.8898.115.1381.281.2185.456.2206l-.811.0561c-.161.0109-.31.088-.415.2141-.106.1261-.158.2909-.146.4582.012.1672.088.3232.21.4336s.281.1661.442.1548l5.074-.3508c.191-.0135.364-.1199.466-.2872.103-.1673.123-.3758.055-.5625-.239-.6565-.682-1.2024-1.267-1.5756-.584-.3764-1.266-.5396-1.975-.4905zm.09 1.2586c.492-.034.886.0677 1.253.3053l.005.0019c.068.0433.077.1215.136.1685l-3.033.2098c.117-.015.227-.0653.317-.1449.368-.3281.784-.5033 1.323-.5406z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path661",
    d: "m132.71 71.742c-1.523.1053-2.826.7648-3.774 1.9305-.944 1.1605-1.366 2.6164-1.25 4.2327.115 1.5849.747 2.9482 1.852 3.9527l.003-2e-4c1.112 1.0044 2.531 1.4542 4.123 1.3442 1.016-.0702 1.913-.3187 2.67-.7673l.002-.0023c.754-.4548 1.381-1.1183 1.866-1.9554.172-.2975.078-.6854-.209-.8669-.139-.0877-.305-.1147-.461-.0753-.157.0395-.291.1422-.374.2856-.394.6813-.867 1.1742-1.433 1.5165l-.002 1e-4-.002.0023c-.567.3355-1.276.5438-2.148.604-1.337.0925-2.371-.2513-3.239-1.0345-.876-.7958-1.341-1.7806-1.435-3.0873-.097-1.3466.22-2.4099.966-3.3276.753-.9252 1.688-1.407 2.935-1.4932 1.341-.0928 2.375.2599 3.246 1.0658l.002-1e-4c.83.7632 1.285 1.8001 1.418 3.186l-6.905.4774c-.177.0122-.34.1051-.446.2539-.105.1488-.141.3386-.099.5191.187.8043.605 1.4889 1.221 1.9559.002.002.004.004.007.006.629.4642 1.41.6546 2.25.5966 1.017-.0703 1.92-.5285 2.597-1.3174.107-.1244.162-.2885.152-.456-.01-.1674-.083-.3245-.204-.4366-.251-.2327-.635-.2119-.857.0466-.49.5714-1.045.854-1.779.9048-.623.0431-1.079-.0857-1.457-.3633-.161-.1223-.204-.3577-.316-.5184l6.551-.453c.33-.0236.578-.3166.56-.6595l-.025-.4644c0-.0042-.001-.0084-.001-.0126-.125-1.7317-.749-3.1786-1.866-4.2059-1.113-1.0293-2.539-1.494-4.139-1.3834z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path663",
    d: "m185.52 70.484c-.765.053-1.466.338-2.028.8395-.253.2264-.28.6247-.06.8898.118.1429.292.2241.472.2215l-.827.0572c-.161.011-.31.088-.416.2142-.105.1261-.157.2909-.145.4581.026.3474.318.6098.652.5864l5.073-.3509c.191-.0136.363-.1197.466-.2865.103-.1667.123-.3746.056-.561-.239-.6565-.682-1.2024-1.267-1.5756-.585-.3765-1.267-.5417-1.976-.4927zm.091 1.2607c.492-.0339.885.0657 1.253.3033l.004.004c.068.0434.078.1215.137.1685l-3.034.2098c.118-.0149.228-.0653.318-.1448.368-.3282.783-.5034 1.322-.5407z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path665",
    d: "m185.26 68.432c-1.522.1053-2.825.767-3.773 1.9326-.944 1.1606-1.364 2.6163-1.248 4.2327.115 1.5848.745 2.9461 1.85 3.9506l.002.002c1.113 1.0045 2.532 1.4543 4.124 1.3442 1.015-.0702 1.913-.3187 2.67-.7673l.004-.0024c.754-.4549 1.379-1.1203 1.864-1.9574.172-.2974.078-.6854-.21-.8669-.287-.1811-.66-.0871-.832.2101-.394.6814-.869 1.1765-1.435 1.5188l-.002 2e-4-.002.0023c-.567.3354-1.276.5416-2.148.6019-1.337.0924-2.371-.2498-3.239-1.0324l-.002-.0021c-.875-.7955-1.339-1.7798-1.433-3.0853-.097-1.3466.222-2.4122.968-3.3298.753-.9253 1.686-1.4048 2.933-1.4911 1.341-.0927 2.375.2579 3.246 1.0638l.002.002c.83.7628 1.285 1.7992 1.418 3.1839l-6.905.4775c-.178.0122-.341.105-.446.2538s-.141.3386-.099.5191c.186.8043.605 1.491 1.221 1.958.002.0013.004.0026.007.0039.629.4641 1.41.6567 2.25.5987 1.017-.0704 1.922-.5308 2.599-1.3196.221-.2594.197-.6577-.054-.8904s-.634-.2119-.857.0465c-.49.5714-1.045.852-1.779.9027-.623.0431-1.079-.0856-1.457-.3632-.16-.1221-.204-.3561-.316-.5163l6.552-.4531c.329-.0236.578-.3165.559-.6595l-.023-.4666c0-.0036 0-.0072-.001-.0108-.124-1.7306-.75-3.1787-1.866-4.2059-1.113-1.0302-2.541-1.496-4.141-1.3853z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fillOpacity: 0.89412,
      fill: "#5fe4d6",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      stroke: "none",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "light_1.begin",
    dur: "1s",
    values: "1;0.5"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "light_1.end",
    dur: "1s",
    values: "0.5;1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "halo",
    style: {
      fill: "none",
      filter: "url(#filter5777)",
      opacity: 0.83976,
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6"
    },
    "aria-label": "Get the Code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path668",
    d: "m82.913 74.151c-1.3761.0915-2.5667.6731-3.4477 1.7014l-.0019.0023c-.8718 1.0248-1.2816 2.2926-1.1863 3.6674.0983 1.4174.7008 2.6528 1.7433 3.5742 1.0447.9233 2.3362 1.3529 3.7466 1.2591.915-.0608 1.7182-.319 2.3672-.7992.6576-.4827 1.1497-1.1971 1.4776-2.081.0749-.2012.0451-.4292-.079-.604-.1241-.1747-.3252-.272-.5329-.2577l-3.6568.2431c-.1608.0106-.3106.0872-.4161.213-.1056.1259-.1583.2906-.1466.4578.0115.1673.0865.3235.2084.4342.122.1107.2809.1668.4418.156l2.3891-.1589c-.1392.1686-.2296.4468-.3927.5663l-.0021 1e-4c-.434.3212-1.0003.5199-1.7453.5694-1.1424.0759-2.0585-.2344-2.8761-.9569-.8197-.7245-1.2361-1.5784-1.3136-2.6962-.0747-1.077.2066-1.9469.8874-2.7471.6827-.7959 1.5161-1.2087 2.623-1.2823 1.2646-.0841 2.3577.3375 3.4106 1.3493.1188.1145.2763.1755.4376.1696.1613-.006.3132-.0784.422-.2014.2263-.255.2096-.6539-.0373-.8915-1.2513-1.2024-2.7345-1.7924-4.3203-1.687z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path670",
    d: "m82.724 71.698c-2.2415.149-4.0906 1.1276-5.3936 2.8751-1.0987 1.4701-1.5977 3.1992-1.4676 5.0757.0949 1.3701.5117 2.6451 1.2385 3.7878l2e-4.0022c.7333 1.1429 1.6975 2.02 2.8612 2.5954.0014 6e-4.0028.0012.0042.0019 1.17.5686 2.4713.8016 3.8694.7087 1.3108-.0872 2.4726-.4578 3.4427-1.1271.9648-.6656 1.7246-1.5975 2.2664-2.752.5438-1.1587.7799-2.3878.6927-3.6451-3e-4-.0063-7e-4-.0127-.0013-.019l-.0567-.5534c-.0342-.3385-.3201-.5902-.6466-.5692l-6.3542.4225c-.1609.0106-.3106.0872-.4162.213-.1055.1259-.1582.2905-.1465.4578.0115.1673.0864.3235.2084.4342.1219.1107.2809.1668.4417.156l5.7437-.3819c.0569 1.0096-.1111 1.9737-.5572 2.9243-.4603.9807-1.072 1.72-1.8524 2.2585-.7751.5347-1.7127.8468-2.8517.9225-1.2219.0812-2.299-.1184-3.2703-.5897l-.0042-.0018c-.9652-.4781-1.7422-1.1832-2.3616-2.1478-.6156-.968-.9587-2.0132-1.0394-3.1783-.1109-1.5989.2849-2.9681 1.2175-4.2159 1.1065-1.4846 2.561-2.2632 4.5203-2.3935 1.0243-.0681 1.9801.0649 2.886.3949l-2e-4-.0021c.73.2662 1.4927.7714 2.279 1.5431.2445.2405.6288.231.8583-.021.2294-.2522.2173-.6516-.0272-.8921-.8796-.8634-1.7821-1.4786-2.7157-1.8192-1.0645-.3878-2.194-.5426-3.3676-.4645z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path672",
    d: "m95.668 74.36c-1.5228.1013-2.8271.7595-3.7787 1.9226-.9473 1.158-1.3735 2.6127-1.2614 4.2294.1099 1.5852.7381 2.948 1.841 3.9554 1.1097 1.0074 2.5299 1.4629 4.1222 1.3571 1.0154-.0675 1.9118-.3156 2.6693-.7622l.0039-.0024c.7559-.4528 1.3849-1.1147 1.8719-1.9504.173-.297.08-.6852-.207-.8675-.138-.088-.304-.1155-.461-.0765-.156.039-.291.1414-.374.2845-.3968.6808-.8717 1.1721-1.4398 1.5129-.5684.3351-1.2773.5425-2.1507.6006-1.3371.0889-2.3707-.2561-3.2364-1.041l-.0022-.002c-.8724-.7979-1.3339-1.7834-1.4244-3.0892-.0934-1.3468.2265-2.4114.9755-3.3271.7554-.9232 1.6917-1.4004 2.9392-1.4833 1.3413-.0892 2.3739.2641 3.2426 1.0723l.0022.002c.8274.765 1.28 1.8026 1.409 3.1877l-6.906.4591c-.1778.0117-.3411.1041-.4466.2526-.1054.1486-.1423.3383-.101.5189.1846.8047.6008 1.4905 1.2157 1.9591.0022.002.0044.0041.0066.0061.6282.4658 1.4085.6604 2.2485.6046 1.017-.0676 1.9215-.5255 2.6006-1.3126.2225-.2583.2004-.6567-.0496-.8906-.2503-.2334-.6336-.2136-.8567.0443-.4919.5701-1.0472.8491-1.7817.898-.6235.0414-1.0784-.0885-1.4558-.3672-.1606-.1227-.2029-.3582-.3151-.5192l6.5511-.4355c.329-.0216.58-.313.564-.6561l-.025-.4665v-.0108c-.12-1.7309-.74-3.1808-1.853-4.2109-1.1105-1.0332-2.5365-1.5027-4.1372-1.3963z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path674",
    d: "m104.92 70.398c-.161.0105-.311.0872-.417.213-.105.1258-.158.2905-.146.4578l.248 3.5783c.011.1673.086.3235.208.4342s.281.1668.442.156l.785-.0522.058.8371-.785.0522c-.161.0106-.311.0872-.416.213-.106.1258-.158.2905-.147.4578l.528 7.6142c.012.1673.087.3235.209.4342.121.1107.28.1668.441.1559.334-.023.585-.3231.561-.6706l-.484-6.9837.785-.0522c.161-.0106.31-.0872.416-.2131.105-.1258.158-.2905.146-.4577l-.145-2.0981c-.025-.3474-.316-.6105-.65-.588l-.785.0521-.204-2.9499c-.024-.3475-.314-.6117-.648-.5903z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path676",
    d: "m114.6 69.755c-.334.0231-.585.3232-.561.6707l.248 3.5783c.024.3475.314.6116.648.5903l.785-.0522.058.8371-.785.0522c-.334.0231-.585.3232-.56.6706l.527 7.6143c.024.3475.314.6116.649.5902.16-.0105.31-.0871.416-.213.105-.1258.158-.2905.146-.4578l-.484-6.9837.785-.0522c.161-.0105.311-.0872.416-.213.106-.1258.158-.2905.147-.4578l-.146-2.098c-.025-.3475-.316-.6106-.65-.5881l-.785.0522-.204-2.9499c-.012-.1673-.087-.3235-.208-.4342-.122-.1107-.281-.1668-.442-.156z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path678",
    d: "m112.26 69.908c-.333.0231-.584.3218-.561.6686l.205 2.9499-.596.0397c-.161.0105-.311.0872-.417.213-.105.1258-.158.2905-.146.4578l.145 2.098c.012.1673.087.3235.209.4342s.281.1668.441.156l.597-.0397.484 6.9838c.024.3475.314.6116.648.5903.161-.0106.311-.0872.416-.213.106-.1259.158-.2906.147-.4578l-.528-7.6142c-.012-.1673-.087-.3235-.209-.4342s-.28-.1668-.441-.156l-.597.0397-.058-.8372.597-.0396c.161-.0106.31-.0872.416-.213.105-.1259.158-.2906.146-.4578l-.248-3.5804c-.025-.3475-.316-.6106-.65-.5881z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path680",
    d: "m122.55 74.81c-.609.0405-1.175.31-1.591.7646-.001.0016-.003.0031-.004.0046-.407.4519-.658 1.0414-.766 1.7096-.076.4669-.044 1.1008.029 2.1566l.271 3.901c.011.1672.086.3234.208.4341.122.1108.281.1669.442.156.161-.0105.311-.0872.416-.213.106-.1258.158-.2905.147-.4578l-.271-3.9009c-.071-1.027-.063-1.7295-.043-1.8549v-.0022c.077-.478.233-.8102.455-1.0576.225-.2456.453-.3564.794-.379.263-.0175.423.0321.561.1279.003.0013.005.0026.007.0039.133.09.25.2354.348.5297.084.2509.205 1.0097.281 2.1145l.296 4.2573c.011.1672.086.3234.208.4342.122.1107.281.1668.442.1559.161-.0105.31-.0871.416-.213.105-.1258.158-.2905.146-.4578l-.295-4.2572c-.079-1.1448-.168-1.9058-.346-2.4385-.163-.4884-.441-.9099-.838-1.1793-.38-.2624-.844-.3697-1.313-.3385z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path682",
    d: "m120.11 69.219c-.335.0219-.586.3211-.563.6686l.328 4.7318c.017.2463.171.4608.393.549.223.0882.474.0338.642-.1391.392-.4032.782-.6989 1.164-.8972.002-8e-4.004-.0017.006-.0026.383-.2034.761-.3111 1.151-.337.786-.0523 1.397.1635 1.966.6848.436.4049.719 1.0458.789 2.0574l.445 6.4187c.024.3475.314.6116.648.5902.161-.0105.311-.0871.416-.213.106-.1258.158-.2905.147-.4577l-.445-6.4187c-.085-1.2248-.464-2.2407-1.195-2.918l-.004-.0019c-.793-.7262-1.788-1.0737-2.855-1.0028-.56.0373-1.107.1997-1.624.4744-.179.0936-.339.2721-.512.3921l-.249-3.591c-.025-.3466-.315-.6095-.648-.5881z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path684",
    d: "m117.79 69.371c-.334.0219-.586.3211-.563.6687l.934 13.461c.011.1673.086.3235.208.4342s.281.1668.442.156c.161-.0106.31-.0872.416-.2131.106-.1258.158-.2905.146-.4577l-.933-13.461c-.025-.3475-.315-.6106-.65-.5881z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path686",
    d: "m150.99 69.606c-1.345.0895-2.513.6746-3.38 1.7012l-.002 2e-4c-.862 1.0275-1.26 2.3092-1.163 3.7081.067.9662.335 1.8471.809 2.5983.474.7489 1.126 1.3313 1.917 1.7198.791.3891 1.66.5527 2.57.4921.773-.0513 1.491-.2491 2.131-.5992l.004-.0024c.654-.365 1.296-.9516 1.969-1.7472.22-.2605.195-.6587-.057-.8901-.253-.2309-.636-.2074-.857.0525-.612.7237-1.171 1.2092-1.636 1.4688l-.002.0023c-.478.2606-1.017.4151-1.639.4564-.726.0483-1.37-.0776-1.971-.3731-.603-.2961-1.061-.7088-1.415-1.268-.352-.557-.558-1.2074-.612-1.9908-.077-1.1116.203-1.9949.87-2.7905.674-.7975 1.482-1.2064 2.552-1.2776 1.26-.0838 2.402.3691 3.54 1.4593.119.1143.277.1749.438.1686.161-.0064.313-.0792.422-.2024.225-.2555.208-.6544-.04-.8913-1.325-1.269-2.846-1.9016-4.448-1.7951z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path688",
    d: "m150.86 67.177c-1.323.0879-2.556.5102-3.66 1.2558l-.002.0023c-1.096.7434-1.937 1.7067-2.487 2.8641l-.002.0023c-.546 1.1605-.764 2.4642-.667 3.868.149 2.158.969 3.9664 2.426 5.2891l.003.002c1.463 1.3163 3.306 1.9091 5.397 1.7701 1.131-.0752 2.149-.3359 3.036-.7971l.004-.0024c.898-.4736 1.783-1.2432 2.684-2.2904.222-.2588.199-.6572-.052-.8905-.12-.1125-.279-.1708-.44-.1621-.161.0086-.311.0836-.418.2083-.833.9683-1.619 1.6312-2.329 2.0062-.722.3752-1.573.6024-2.571.6688-1.835.122-3.297-.3616-4.519-1.4599l-.002-.002c-1.217-1.1057-1.875-2.5335-2.006-4.4211-.084-1.2147.102-2.2765.549-3.2267.453-.9522 1.128-1.7331 2.062-2.3677.939-.6337 1.954-.9815 3.081-1.0564.956-.0636 1.88.082 2.796.4454l.002.002c.919.3622 1.717.9042 2.414 1.6401.236.2491.621.2538.859.0107.115-.117.179-.2771.18-.4449s-.063-.3294-.177-.4493c-.816-.8609-1.774-1.5115-2.852-1.9371l-.002 1e-4c-1.071-.4246-2.181-.6028-3.307-.5279z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path690",
    d: "m163.02 72.18c-.869.0577-1.643.4568-2.189 1.139l-.002 2e-4c-.545.6819-.784 1.5624-.718 2.5113.067.9678.419 1.82 1.05 2.4277.248.2372.631.223.858-.0316.227-.2545.211-.6535-.035-.8916-.392-.3766-.61-.8628-.66-1.5851-.048-.6934.1-1.1889.444-1.6183.353-.4418.754-.6539 1.339-.6928.607-.0404 1.033.1162 1.428.4961.002.002.005.004.007.006.395.3719.613.844.662 1.5511.049.7057-.104 1.211-.453 1.6464-.352.4408-.755.654-1.347.6933-.335.0219-.586.3212-.563.6687.011.1673.086.3235.208.4342s.281.1668.442.156c.873-.0581 1.652-.4565 2.199-1.1397.551-.6886.791-1.5787.724-2.5394-.066-.9584-.424-1.8018-1.061-2.4015-.627-.6021-1.454-.8884-2.333-.8299z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path692",
    d: "m162.84 69.89c-1.36.0904-2.572.6862-3.54 1.7267l-.002 1e-4c-1.105 1.1957-1.624 2.7099-1.508 4.3814.109 1.5619.75 2.9205 1.872 3.9513l.004.0018c1.126 1.0227 2.494 1.5077 3.977 1.4091 1.005-.0668 1.935-.3805 2.747-.9367l.002-.0023c.81-.562 1.44-1.3195 1.864-2.2402l-.001-.0021c.429-.9199.612-1.911.541-2.9317-.07-1.0148-.384-1.9641-.93-2.8085-.549-.848-1.294-1.5121-2.194-1.964-.303-.1518-.666-.0205-.809.2931-.144.3138-.015.6911.288.843.72.361 1.277.8608 1.708 1.5261.432.6687.67 1.3846.726 2.1908.056.8114-.082 1.5618-.424 2.2948l-.001.0044c-.336.7304-.81 1.2975-1.447 1.74-.637.4369-1.342.6803-2.157.7345-1.195.0794-2.184-.2698-3.094-1.095l-.002-.002c-.903-.8309-1.371-1.8172-1.459-3.0869-.094-1.3635.281-2.4531 1.177-3.4231.786-.8443 1.671-1.2719 2.749-1.3436.161-.0106.311-.0872.416-.213.106-.1259.159-.2906.147-.4578-.012-.1673-.087-.3235-.209-.4342s-.28-.1668-.441-.156z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path694",
    d: "m178.71 65.323c-.334.0219-.586.3211-.563.6687l.933 13.461c.012.1672.087.3234.209.4341s.28.1669.441.156c.161-.0105.311-.0872.417-.213.105-.1258.158-.2905.146-.4578l-.933-13.461c-.025-.3474-.316-.6106-.65-.588z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path696",
    d: "m176.37 65.476c-.334.0219-.586.3211-.563.6687l.252 3.6289c-.187-.1008-.349-.2704-.545-.3429-.587-.2166-1.209-.3031-1.846-.2607-1.372.0912-2.563.7435-3.44 1.8746-.885 1.1422-1.267 2.5879-1.154 4.2118.109 1.5792.709 2.9407 1.768 3.9644v.0022c1.051 1.0094 2.326 1.504 3.69 1.4133.609-.0405 1.181-.1911 1.7-.4562l.005-3e-4c.189-.098.35-.3.53-.4314.084.2811.342.4667.624.4479.334-.0231.585-.3232.561-.6707l-.072-1.0269c-.018-.2511-.178-.4681-.407-.5522-.229-.0842-.483-.0195-.646.1647-.388.4384-.769.7442-1.138.9357-.369.1885-.777.2995-1.244.3306-1.052.0699-1.934-.2644-2.781-1.0777-.839-.811-1.288-1.8108-1.379-3.1239-.096-1.3755.203-2.4467.891-3.3342.696-.8985 1.513-1.3398 2.58-1.4107.484-.0322.931.031 1.359.1892.428.1579.835.411 1.232.776.185.1699.45.2075.67.0954.221-.1121.353-.3518.336-.6071l-.335-4.8203c-.024-.3466-.314-.6095-.648-.5881zm-73.784 5.0751c-.334.0231-.585.3232-.561.6707l.205 2.9478-.597.0396c-.161.0106-.31.0872-.416.2131-.105.1258-.158.2905-.146.4577l.145 2.0981c.012.1673.087.3235.208.4342.122.1107.281.1668.442.156l.597-.0397.484 6.9837c.023.3476.313.6117.648.5903.161-.0105.31-.0871.416-.213.105-.1258.158-.2905.146-.4578l-.527-7.6142c-.012-.1672-.087-.3234-.209-.4341s-.281-.1668-.442-.156l-.594.0395-.058-.8371.594-.0395c.161-.0106.311-.0872.417-.2131.105-.1258.158-.2905.146-.4577l-.248-3.5783c-.011-.1673-.086-.3235-.208-.4342s-.281-.1669-.442-.156zm30.366 3.1943c-.766.0509-1.467.334-2.03.8341-.254.2257-.282.6239-.063.8896.114.1384.28.2192.455.2218l-.811.0539c-.161.0106-.311.0872-.416.213-.106.1259-.158.2906-.147.4578.012.1673.087.3235.209.4342s.281.1668.442.156l5.074-.3374c.191-.013.364-.1189.468-.286.103-.167.124-.3754.056-.5623-.238-.6571-.679-1.2042-1.263-1.5789-.583-.378-1.265-.543-1.974-.4958zm.087 1.2588c.492-.0326.885.0702 1.252.3087l.005.0019c.068.0435.077.1217.136.1689l-3.034.2017c.117-.0146.228-.0647.318-.144.368-.3272.784-.5013 1.323-.5371z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path698",
    d: "m132.7 71.693c-1.523.1012-2.828.7573-3.779 1.9205-.947 1.158-1.374 2.6127-1.262 4.2294.11 1.5852.739 2.9501 1.842 3.9575l.002-1e-4c1.109 1.0073 2.527 1.4609 4.12 1.3551 1.015-.0676 1.914-.3136 2.671-.7602l.002-.0023c.756-.4528 1.385-1.1147 1.872-1.9504.172-.297.08-.6852-.207-.8675-.138-.088-.304-.1155-.461-.0765-.156.039-.291.1414-.374.2845-.397.6803-.87 1.172-1.438 1.5128l-.002 1e-4-.002.0023c-.568.3339-1.277.5404-2.149.5983-1.337.0889-2.37-.2576-3.236-1.0431-.874-.7982-1.336-1.7842-1.427-3.0911-.093-1.3469.227-2.4093.976-3.325.755-.9232 1.691-1.4025 2.939-1.4855 1.341-.0891 2.374.2663 3.243 1.0745l.002-1e-4c.828.7654 1.28 1.8034 1.409 3.1897l-6.906.4591c-.178.0118-.341.1042-.447.2527-.105.1485-.142.3382-.101.5188.185.8048.601 1.4906 1.216 1.9591.002.0021.004.0041.007.0061.628.4658 1.408.6584 2.248.6025 1.017-.0676 1.922-.5233 2.601-1.3104.107-.1242.162-.2881.153-.4556s-.082-.3248-.203-.4372c-.25-.2333-.634-.2135-.857.0443-.492.5701-1.047.8513-1.781.9001-.624.0415-1.079-.0885-1.456-.3671-.161-.1228-.203-.3583-.315-.5192l6.553-.4357c.329-.0227.579-.3151.561-.658l-.023-.4645c-.001-.0042-.001-.0084-.001-.0126-.12-1.732-.741-3.1805-1.855-4.2108-1.11-1.0323-2.535-1.5007-4.135-1.3943z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path700",
    d: "m185.51 70.575c-.765.0509-1.467.334-2.03.8341-.254.2257-.282.624-.063.8896.118.1433.291.225.472.2228l-.827.055c-.161.0106-.311.0872-.417.2131-.105.1258-.158.2905-.146.4577.025.3475.316.6106.65.5881l5.074-.3374c.191-.0131.364-.1188.467-.2852.103-.1665.124-.3743.057-.561-.237-.657-.678-1.2041-1.262-1.5789-.584-.378-1.265-.545-1.975-.4979zm.088 1.261c.491-.0327.885.068 1.252.3065l.004.0041c.068.0435.077.1217.136.1688l-3.034.2018c.118-.0147.228-.0647.318-.144.369-.3272.785-.5013 1.324-.5371z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path702",
    d: "m185.26 68.522c-1.523.1013-2.827.7595-3.779 1.9226-.947 1.1581-1.371 2.6127-1.259 4.2293.11 1.5852.736 2.9482 1.839 3.9556l.002.002c1.11 1.0074 2.528 1.4609 4.12 1.3551 1.016-.0675 1.914-.3136 2.672-.7602l.004-.0024c.756-.4529 1.383-1.1167 1.869-1.9524.173-.2971.08-.6852-.207-.8675-.287-.1819-.66-.0889-.833.2079-.396.6803-.872 1.1742-1.439 1.515l-.002 1e-4-.002.0023c-.568.3339-1.277.5383-2.149.5962-1.337.0889-2.371-.2561-3.236-1.041l-.003-.002c-.872-.7978-1.334-1.7834-1.424-3.0892-.093-1.3468.228-2.4115.977-3.3272.756-.9232 1.69-1.4003 2.938-1.4832 1.341-.0892 2.374.2641 3.242 1.0724l.002.002c.828.765 1.28 1.8025 1.409 3.1876l-6.906.4591c-.177.0118-.341.1042-.446.2527-.106.1485-.143.3382-.101.5188.184.8048.601 1.4927 1.216 1.9613l.006.0039c.628.4658 1.409.6604 2.249.6046 1.017-.0676 1.923-.5256 2.602-1.3127.222-.2588.199-.6572-.051-.8905-.25-.2334-.634-.2136-.857.0442-.492.5702-1.047.8492-1.781.898-.624.0415-1.079-.0885-1.456-.3671-.16-.1225-.203-.3566-.315-.5171l6.553-.4357c.329-.0227.579-.315.561-.658l-.022-.4667v-.0108c-.12-1.7309-.742-3.1806-1.855-4.2108-1.11-1.0331-2.536-1.5027-4.137-1.3963z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "none",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      imageRendering: "auto",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 1,
      shapeMargin: 0,
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      stopColor: "#000000",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeWidth: 1.0296,
      stroke: "#5fd3d6",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    id: "light_1",
    attributeName: "opacity",
    begin: "0s;light_2.end +0.5s",
    dur: "1s",
    values: "0.8;0"
  })), _animate4 || (_animate4 = /*#__PURE__*/React.createElement("animate", {
    id: "light_2",
    attributeName: "opacity",
    begin: "light_1.end",
    dur: "1s",
    values: "0;0.8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "wireOn",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.89412,
      strokeWidth: 0.3,
      stroke: "#fffdfd"
    },
    "aria-label": "Get the Code"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path705",
    d: "m86.848 76.473c-1.1552-1.104-2.4452-1.6068-3.8701-1.5082-1.2418.0858-2.2525.5862-3.032 1.5012-.7737.9145-1.1165 1.9847-1.0281 3.2103.0914 1.2674.6037 2.3112 1.5371 3.1316.9334.8205 2.0382 1.1866 3.3144 1.0983.8298-.0574 1.5148-.2871 2.0552-.6892.5461-.4026.9659-1.0026 1.2592-1.8002l-3.6569.2529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path707",
    d: "m83.257 79.314 6.3524-.4392.0571.5521c.0827 1.1483-.1249 2.257-.6229 3.3259-.4981 1.0689-1.1826 1.9055-2.0535 2.5099-.8709.6043-1.9186.9488-3.1433 1.0335-1.3106.0907-2.5021-.1229-3.5747-.6407-1.0673-.5242-1.9408-1.3128-2.6207-2.3661-.6741-1.0536-1.0568-2.2141-1.1482-3.4815-.1253-1.7374.318-3.2867 1.3299-4.6484 1.2003-1.6197 2.8505-2.5022 4.9509-2.6474 1.0987-.076 2.1413.0642 3.1274.4206.8327.3012 1.6666.8594 2.5018 1.6747"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path709",
    d: "m100.66 82.916c-.44.7599-.9908 1.3391-1.6523 1.7378-.6619.3925-1.4649.6215-2.4091.6868-1.4651.1013-2.6928-.2952-3.6832-1.1894-.9909-.9002-1.5385-2.0732-1.6427-3.519-.1068-1.4814.2624-2.7418 1.1077-3.7809.8506-1.0454 1.9684-1.6161 3.3533-1.7119 1.4707-.1017 2.7022.3065 3.6943 1.2246.992.912 1.546 2.1712 1.661 3.7777l.025.4647-7.5281.5206c.1585.6827.4872 1.2131.986 1.5911.5042.3718 1.1225.5323 1.8551.4817.8756-.0606 1.6052-.4309 2.1887-1.1111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path711",
    d: "m104.98 71.152.258 3.5789 1.391-.0961.151 2.0973-1.39.0961.549 7.6129"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path713",
    d: "m114.65 70.483.258 3.5789 1.39-.0962.151 2.0973-1.39.0962.549 7.6128"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path715",
    d: "m113.28 83.931-.549-7.6129-1.202.0831-.151-2.0973 1.201-.0831-.258-3.5789"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path717",
    d: "m124.78 83.136-.307-4.2571c-.081-1.1245-.187-1.8826-.319-2.2741s-.331-.6767-.597-.8556c-.26-.1794-.573-.2564-.94-.231-.475.0328-.872.2247-1.192.5757-.314.3506-.516.8131-.607 1.3874-.048.2963-.034.965.041 2.0063l.281 3.9001"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path719",
    d: "m120.16 69.932.341 4.7302c.428-.4422.867-.7805 1.316-1.0148.448-.2403.91-.3769 1.385-.4098.927-.0641 1.732.2151 2.415.8376.586.5395.919 1.3686.999 2.4871l.463 6.4169"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path721",
    d: "m118.81 83.548-.97-13.458"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path723",
    d: "m155.04 71.855c-1.235-1.1763-2.568-1.7149-3.999-1.616-1.207.0835-2.195.5823-2.963 1.4965-.762.9138-1.098 1.9984-1.008 3.2537.063.8747.302 1.6384.718 2.2914.415.653.971 1.1497 1.669 1.4901.697.3404 1.455.4824 2.273.4258.698-.0483 1.327-.2263 1.886-.534.558-.3137 1.157-.8514 1.798-1.6133"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path725",
    d: "m157.17 78.704c-.865 1.0105-1.699 1.7289-2.502 2.1552-.803.4204-1.737.6673-2.802.7409-1.963.1358-3.617-.3986-4.964-1.603-1.341-1.2108-2.084-2.8277-2.23-4.8507-.095-1.309.105-2.4918.598-3.5484.499-1.057 1.255-1.9315 2.269-2.6235 1.02-.6924 2.143-1.081 3.367-1.1656 1.042-.0721 2.06.0878 3.054.4794 1 .3913 1.88.9852 2.639 1.7818"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path727",
    d: "m163.48 78.431c.732-.0506 1.323-.3575 1.771-.9207s.642-1.2612.582-2.0942-.349-1.4916-.867-1.9761c-.513-.4907-1.141-.7104-1.885-.6589-.727.0502-1.314.3569-1.763.9201-.443.5568-.635 1.2459-.575 2.0669.061.8448.347 1.5126.86 2.0034"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path729",
    d: "m165.42 71.007c.812.4043 1.463.9841 1.955 1.7394.491.7553.77 1.5882.835 2.4984.066.9163-.092 1.7883-.475 2.616-.378.8274-.928 1.4933-1.651 1.9977-.723.4985-1.539.7792-2.449.8421-1.339.0926-2.52-.3221-3.541-1.2441-1.016-.9283-1.575-2.1005-1.677-3.5165-.109-1.5172.335-2.8186 1.332-3.9041.875-.9455 1.922-1.4604 3.141-1.5446"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path731",
    d: "m178.75 65.88.971 13.458"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path733",
    d: "m130.58 76.432 5.073-.3509c-.193-.5307-.531-.9498-1.014-1.2573-.476-.3079-1.015-.4411-1.616-.3995-.652.0451-1.211.2751-1.675.6899m46.04 4.3843-.074-1.0263c-.425.4838-.862.8429-1.311 1.0773-.444.228-.934.3606-1.472.3978-1.208.0835-2.287-.3292-3.238-1.2381-.952-.9148-1.48-2.0951-1.584-3.541-.108-1.4994.229-2.7575 1.013-3.7744s1.785-1.5675 3.004-1.6518c.561-.0388 1.095.0349 1.603.221s.987.4848 1.437.8962l-.348-4.8193m-72.811 18.56-.549-7.6128-1.201.0831-.152-2.0973 1.202-.0831-.258-3.5789"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path735",
    d: "m137.68 80.15c-.44.76-.99 1.3391-1.652 1.7378-.662.3925-1.465.6215-2.409.6868-1.465.1013-2.693-.2952-3.683-1.1894-.991-.9002-1.538-2.0732-1.643-3.5189-.107-1.4815.263-2.7419 1.108-3.781.851-1.0454 1.968-1.6161 3.353-1.7119 1.471-.1017 2.703.3065 3.695 1.2246.991.912 1.545 2.1713 1.661 3.7777l.025.4647-7.528.5206c.158.6827.487 1.2131.986 1.5911.504.3718 1.122.5323 1.855.4816.875-.0605 1.605-.4309 2.189-1.111"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path737",
    d: "m183.12 73.124 5.073-.3508c-.193-.5308-.531-.9499-1.014-1.2574-.476-.3079-1.015-.441-1.616-.3995-.652.0451-1.211.2751-1.676.6899"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path739",
    d: "m190.24 76.841c-.44.76-.991 1.3391-1.652 1.7378-.662.3925-1.465.6215-2.41.6868-1.465.1013-2.692-.2952-3.683-1.1894-.991-.9002-1.538-2.0732-1.642-3.5189-.107-1.4815.262-2.7419 1.107-3.781.851-1.0454 1.969-1.6161 3.354-1.7119 1.47-.1017 2.702.3065 3.694 1.2246.992.912 1.545 2.1713 1.661 3.7777l.025.4647-7.528.5206c.159.6827.487 1.2131.986 1.5911.504.3718 1.123.5323 1.855.4816.876-.0605 1.605-.4309 2.189-1.111"
  })), _animate5 || (_animate5 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-width",
    begin: "light_1.begin",
    dur: "1s",
    values: ".28;.15"
  })), _animate6 || (_animate6 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-width",
    begin: "light_1.end",
    dur: "1s",
    values: ".15;.28"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "wireOff",
    d: "m176.53 76.742c.22292-.28332.38267-.60303.4792-.95911.0974-.35921.13045-.75544.0993-1.1886-.061-.84488-.35346-1.5123-.87764-2.0023-.5242-.48999-1.1583-.7092-1.9023-.65776-.72679.05026-1.3113.35976-1.7534.92849-.44252.56277-.63378 1.2606-.57371 2.0936.0605.83893.35347 1.5123.87894 2.0201.5312.5074 1.1545.73636 1.8698.6869m-81.235 1.5095 5.0732-.35082c-.19357-.53075-.53147-.94986-1.0137-1.2574-.47656-.30788-1.0153-.44104-1.6162-.39949-.14775.01021-.29069.03013-.42886.05903-.47174.09969-.88733.30993-1.2468.63079",
    style: {
      fill: "none",
      opacity: 0.69863,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.17,
      stroke: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "tubeOff",
    d: "m95.956 76.678c-.74502.05152-1.4209.32822-1.965.81387a.51603.49617 83.813 00-.04956.72591.51603.49617 83.813 00.7011.0575c.38535-.34398.82794-.52762 1.3877-.56633.51133-.03536.9317.07152 1.3193.32192a.51608.49623 83.813 00.002.0019c.14659.09346.18792.25436.2975.36715l-4.1368.28606a.51603.49617 83.813 00-.45768.54862.51603.49617 83.813 00.53186.48019l5.0734-.35083a.51608.49623 83.813 00.42692-.69268c-.23102-.63348-.65558-1.1561-1.2221-1.5173-.56464-.36356-1.2202-.52369-1.9092-.47605zm78.371-5.2308c-.84276.05827-1.582.44795-2.1021 1.1157-.52439.6669-.75035 1.5203-.68287 2.4562.0679.94234.41693 1.7641 1.0364 2.3627a.51608.49623 83.813 00.002.0019c.61994.59219 1.4063.87949 2.2418.82171a.51603.49617 83.813 00.45769-.54862.51603.49617 83.813 00-.53187-.48019c-.59422.04109-1.0549-.12803-1.4967-.54908l-.002-.0018c-.43023-.41663-.66492-.94059-.71788-1.675-.0526-.73005.10346-1.2727.46413-1.7313a.51608.49623 83.813 00.002-.0021c.36402-.46828.79378-.69899 1.4036-.74116.63227-.04372 1.1039.12362 1.5337.52532.42457.39685.65894.91413.71245 1.6564.0276.38274-.002.71624-.0821 1.0099-.0789.29114-.20519.5444-.38636.77464a.51603.49617 83.813 00.0727.72594.51603.49617 83.813 00.69807-.06942c.26469-.33639.45757-.72239.57171-1.1434.11514-.42473.15238-.8825.11751-1.3663-.0683-.94758-.41999-1.7686-1.0438-2.3517-.61861-.57821-1.4124-.84941-2.268-.79025z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    fill: "#17f5f0",
    fillOpacity: 0.31884,
    imageRendering: "auto",
    opacity: 0.67359,
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fillOpacity: 0.49091,
      fill: "#69fdfa",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      opacity: 0.5549,
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetTheCodeNewAnimated);
export default __webpack_public_path__ + "static/media/Get_the_Code_new_animated.8c8f041f706e214c2cedd7f1fab2459e.svg";
export { ForwardRef as ReactComponent };